import { Component, EventEmitter, OnInit, Output, computed, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { Menu } from '../../models/api-response.model';
import { AuthenticationService } from '../../services/authentication_service';

type SidebarMenuItem = {
  label: string;
  route: string;
  icon: string;
  children: SidebarMenuItem[];
};

@Component({
  selector: 'app-sidebar-menu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss']
})
export class SidebarMenuComponent implements OnInit {
  @Output() readonly collapsedChange = new EventEmitter<boolean>();
  private readonly authService = inject(AuthenticationService);
  readonly assignedMenus = signal<Menu[]>([]);
  readonly menuItems = computed(() => this.buildMenuTree(this.assignedMenus()));
  collapsed = true;

  setCollapsed(collapsed: boolean): void {
    this.collapsed = collapsed;
    this.collapsedChange.emit(this.collapsed);
  }

  ngOnInit(): void {
    const token = this.authService.getToken();
    if (!token) {
      this.assignedMenus.set([]);
      return;
    }

    this.authService.getAssignedMenus().subscribe((response) => {
      this.assignedMenus.set(response.value === '' ? [] : response.value);
    });
  }

  private buildMenuTree(menus: Menu[]): SidebarMenuItem[] {
    const sortMenus = (items: Menu[]) => [...items].sort((first, second) => first.order_no - second.order_no || first.name.localeCompare(second.name));
    const childrenByParent = new Map<number, Menu[]>();
    sortMenus(menus.filter((menu) => menu.parent_menu_id !== null)).forEach((menu) => {
      const parentId = menu.parent_menu_id || 0;
      childrenByParent.set(parentId, [...(childrenByParent.get(parentId) || []), menu]);
    });
    return sortMenus(menus.filter((menu) => menu.parent_menu_id === null)).map((menu) => ({
      label: menu.name,
      route: menu.route_url || '#',
      icon: menu.css_class || '•',
      children: (childrenByParent.get(menu.id) || []).map((child) => ({
        label: child.name,
        route: child.route_url || '#',
        icon: child.css_class || '›',
        children: []
      }))
    })).filter((item) => item.route !== '#' || item.children.length > 0);
  }
}
